<template>
  <div>
    <div
      v-if="
        paymentResult === 'true' &&
        this.$route.query.message === 'payment_done_with_error'
      "
      class="bg-white m-md-5 m-0 p-4"
    >
      <b-row>
        <b-col>
          <b-alert show variant="warning" class="font-weight-bold">
            <i class="fas fa-info-circle fa-lg mr-2" />
            <span v-text="generateMessage" />
          </b-alert>
        </b-col>
      </b-row>
    </div>
    <Wrapper
      v-if="paymentResult === 'true'"
      label="رسید پرداخت"
      :loading="loading"
      :loadingText="loadingText"
      :items="items"
    >
      <template slot="buttons">
        <b-button
          class="mx-2"
          variant="outline-danger"
          :to="{ name: `taskUserPage` }"
          v-text="$lang.back_to_activity"
        />
        <b-button
          class="mx-2"
          variant="primary"
          v-text="$lang.print"
          @click="print"
        />
      </template>
    </Wrapper>
    <div v-else class="bg-white m-md-5 m-0 p-4">
      <b-row>
        <b-col>
          <b-alert show variant="danger" class="font-weight-bold">
            <i class="fas fa-info-circle fa-lg mr-2" />
            <span v-text="generateMessage" />
          </b-alert>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Wrapper from "./Wrapper";
import { pathOr } from "ramda";

export default {
  inject: ["paymentRepository"],
  components: {
    Wrapper,
  },
  data() {
    return {
      id: this.$route.params.id,
      items: {},
      loading: false,
      loadingText: this.$lang.receiving_data,
      paymentResult: pathOr(null, ["result"], this.$route.query),
      systemType: pathOr(null, ["system"], this.$route.query),
    };
  },
  computed: {
    generateMessage() {
      const messages = {
        user_canceled_payment: this.$lang.user_canceled_payment,
        payment_will_undo: this.$lang.payment_will_undo,
        wrong_gate_number: "شماره درگاه پرداخت اشتباه ارسال شده است",
        payed_ago: "این مبلغ قبلا توسط این پرونده پرداخت شده است",
        wrong_data_bank: "مقادیر ارسالی از سمت بانک صحیح نمی باشد",
        payment_done_with_error: this.$lang.payment_done_with_error,
      };
      const key = pathOr(null, ["message"], this.$route.query);
      return pathOr("", [key], messages);
    },
  },
  methods: {
    pathOr,
    print() {
      window.print();
    },
    async getPayment() {
      if (this.paymentResult !== "true" || !this.systemType) return;
      try {
        const response = await this.paymentRepository.find(
          this.id,
          this.systemType
        );
        this.items = { ...pathOr({}, ["data", "data"], response) };
      } catch (error) {
        this.$generateError(error);
      }
    },
  },
  created() {
    this.getPayment();
  },
};
</script>
